import React from 'react';
import { CheckIcon } from './icons';

// Navy toast strip, bottom-left, clears the FAB column on the right.
const CallerToast = ({ message }: { message: string }) => (
  <div className="cid-toast">
    <span className="cid-toast-check"><CheckIcon size={17} /></span>
    <span className="cid-toast-msg">{message}</span>
  </div>
);

export default CallerToast;
